import type { ApiFetch } from '../api/client';
import type { StorageDashboardSummary } from './storageDashboardTypes';

async function readErrorMessage(res: Response): Promise<string> {
  try {
    const data = (await res.json()) as { errorText?: string; message?: string; title?: string };
    return data.errorText ?? data.message ?? data.title ?? res.statusText;
  } catch {
    return res.statusText || 'Request failed.';
  }
}

async function readJson<T>(res: Response): Promise<T> {
  return (await res.json()) as T;
}

export type StorageDashboardCatalog = 'files' | 'spr' | 'all';

export interface FetchStorageDashboardSummaryOptions {
  catalog?: StorageDashboardCatalog;
}

export async function fetchStorageDashboardSummary(
  apiFetch: ApiFetch,
  options?: FetchStorageDashboardSummaryOptions
): Promise<StorageDashboardSummary> {
  const catalog = options?.catalog;
  const qs = catalog && catalog !== 'all' ? `?catalog=${encodeURIComponent(catalog)}` : '';
  const res = await apiFetch(`/api/files/dashboard/summary${qs}`);
  if (!res.ok) throw new Error(await readErrorMessage(res));
  return readJson<StorageDashboardSummary>(res);
}
